<div *ngIf="isLoading" class="loading-overlay">
  <div class="loader-section">
    <div class="preview-box">
      <!-- From Uiverse.io by mobinkakei -->
      <div class="wrapper">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
      </div>
    </div>
  </div>
</div>
